// extracted by mini-css-extract-plugin
module.exports = {"blueOuter":"_2lNho","text":"_1X2q-","circle":"_1kvRv","outer":"_3Romw","greenOuter":"_1-xVk"};